/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D panel stepper
 */

import React from "react";
import PropTypes from "prop-types";
import Banner from "./Banner";
import Tip from "./Tip";

function Stepper({ steps, field, currentStep, setCurrentStep, aframeClasses }) {
    const drawStep = () => {

        return steps[field][currentStep].banner ? (
            <Banner
                data={steps[field][currentStep]}
                setPosition={setCurrentStep}
                aframeClasses={aframeClasses}
            />
        ) : (
            <Tip
                data={steps[field][currentStep]}
                setPosition={setCurrentStep}
                aframeClasses={aframeClasses}
            />
        );
    };

    return <a-entity class="Stepper">{drawStep()}</a-entity>;
}

Stepper.propTypes = {
    steps: PropTypes.object.isRequired
};

export default Stepper;
